import {
  getagents,
  getagentsByChildrenUser,
  getagentsByUser,
} from "../../js/api/getAgents.js";
import { _t } from "../../services/TranslationService.js";
import Utils from "../../services/Utils.js";

let MyBetsUsersAgent = {
  startDate: null,
  endDate: null,
  render: async () => {
    $('body #predefinedRanges .my-bets-tabs__item').unbind('click');

    let role = localStorage.getItem("role");

    let agents = await getagents();
    let agentsView = "";

    let userCoins = [];
    let userCoinsView = ``;

    if (localStorage.getItem("coins")) {
      userCoins = JSON.parse(localStorage.getItem("coins"));

      userCoins.forEach((coin) => {
        userCoinsView += `<option value="${coin.id}">${_t('Monedha')}: ${Utils.currencyCode(coin.currency)}</option>`;
      });
    }

    if (agents && agents.children_users.length !== 0) {
      const allIds = agents.children_users.map(a => a.id);
      const uniqueIds = [...new Set(allIds)];
      uniqueIds.forEach((agentId) => {
        const agent = agents.children_users.find(a => a.id === agentId);
        agentsView =
          agentsView + `<option value="${agent.id}">${agent.username}</option>`;
      });
    }

    if (role == "User") window.location.href = "/";

    let view = /*html*/ `<div class="myBetsWrapper">
             <div class="myBetsHeader">
               <a class="backBtn">
                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"/></svg>
               </a>
               <span>${_t('Baste e mia')}</span>
             </div>

            <div class="newMyBetsFilter">
              <input type="text" readonly  class="form-control" id="myCalendar">
              <button type="button" class="btn-filter">${_t('Filtro')}</button>
            </div>

            <div class="my-bets-tabs" id="predefinedRanges">
            </div> 

            <div class="my-bets-select-filters ${role === "User" ? 'hidden' : ''}">
              <select name="accountCoinSelect" id="myBetsUsersUserCoinSelect" class="${role == "User" ? "hidden" : ""}" placeholder="${_t('Monedha')}">
                  ${userCoinsView}
              </select>
              <select name="accountAgentSelect" id="agentSelect" class="${role == "User" ? "hidden" : ""}">
                <option value="">${_t('Zgjidh perdorues')}</option>
                ${agentsView}
              </select>
            </div>

             <div class="myBetsTable m-t-6" id="myAgents">

             </div>
             <div class="myBetsFooter m-t-6">
               <span>${_t('All')}</span>
               <span></span>
               <span id="totalBetsValue"></span>
             </div>
           </div>
     `;
    return view;
  },
  after_render: async () => {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    let yyyy = today.getFullYear();

    const startFromStore = localStorage.getItem("betsStartDate");
    const endFromStore = localStorage.getItem("betsEndDate");
    const start = startFromStore && startFromStore !== 'Invalid date' ? moment(localStorage.getItem("betsStartDate"), 'YYYY-MM-DD').startOf("day") : moment().startOf("day");
    const end = endFromStore && endFromStore !== 'Invalid date' ? moment(localStorage.getItem("betsEndDate"), 'YYYY-MM-DD').endOf("day") : moment().endOf("day");
    MyBetsUsersAgent.startDate = start.format('YYYY-MM-DD');
    MyBetsUsersAgent.endDate = end.format('YYYY-MM-DD');

    let months = [
      "Janar",
      "Shkurt",
      "Mars",
      "Prill",
      "Maj",
      "Qershor",
      "Korrik",
      "Gusht",
      "Shtator",
      "Tetor",
      "Nentor",
      "Dhjetor",
    ];
    let currentMonthDescription = `${months[today.getMonth()]}`;

    let ranges = {};
    ranges[_t('Sot')] = [moment(), moment()];
    ranges[_t('Dje')] = [moment().subtract(1, "days"), moment().subtract(1, "days")];
    ranges = {
      ...ranges,
      2023: [moment().startOf('year'), moment().endOf('year')],
      2022: [moment().subtract(1, "year").startOf('year'), moment().subtract(1, 'year').endOf('year')],
    };

    ranges[`${currentMonthDescription}`] = [
      moment().startOf("month"),
      moment().endOf("month"),
    ];
    ranges[`${months[today.getMonth() == 0 ? 11 : today.getMonth() - 1]}`] = [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ];

    today = yyyy + "-" + mm + "-" + dd;

    let agents = await getagentsByUser(
      MyBetsUsersAgent.startDate ? MyBetsUsersAgent.startDate : start.format('YYYY-MM-DD'),
      MyBetsUsersAgent.endDate ? MyBetsUsersAgent.endDate : end.format('YYYY-MM-DD'),
      $("#myBetsUsersUserCoinSelect").val()
    );

    renderAgents(agents);

    let totalBet = 0;
    $("body .wonCoefItem").each(function () {
      totalBet += parseFloat(
        $(this).text().substring($(this).text().length, -1)
      );
    });

    let betsStartDate = today;
    let betsEndDate = today;
    saveMetaData(betsStartDate, betsEndDate);
    //$('body #totalBetsValue').text(totalBet);
    async function datePickerCallback(start, end, label) {
      $("#contentLoader").append(
        '<div class="loaderWrapper">\n' +
          '            <div class="loader"></div>\n' +
          "        </div>"
      );
      console.log(
        "New date range selected: " +
          start.format("YYYY-MM-DD") +
          " to " +
          end.format("YYYY-MM-DD") +
          " (predefined range: " +
          label +
          ")"
      );
      let startDate = start.format("YYYY-MM-DD");
      let endDate = end.format("YYYY-MM-DD");

      betsStartDate = startDate;
      betsEndDate = endDate;
      agents = await getagentsByUser(
        startDate,
        endDate,
        $("#myBetsUsersUserCoinSelect").val()
      );

      renderAgents(agents);
      saveMetaData(betsStartDate, betsEndDate);

      //$('body #totalBetsValue').text(totalBet);
      $("body .loaderWrapper").remove();
    }

    $("#myCalendar").daterangepicker(
      {
        // ranges: ranges,
        alwaysShowCalendars: true,
        startDate: start,
        endDate: end,
        opens: "center",
        linkedCalendars: false, // This prevents showing two months
        showCustomRangeLabel: false, 
      },
      datePickerCallback
    );

    $('#predefinedRanges').html('');
    Object.keys(ranges).forEach(key => {
      $('#predefinedRanges').append(`<div class="my-bets-tabs__item" data-value="${key}">${key}</div>`)
    });

    $("body").on("click", "#predefinedRanges .my-bets-tabs__item", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if ($(this).hasClass('active')) {
        return;
      }
      const key = $(this).attr('data-value');
      if (ranges[key] !== undefined) {
        const range = ranges[key];
        if (range && range.length === 2) {
          $('#myCalendar').data('daterangepicker').setStartDate(range[0]);
          $('#myCalendar').data('daterangepicker').setEndDate(range[1]);
          datePickerCallback(range[0], range[1]);
        }
      }

      $('#predefinedRanges .my-bets-tabs__item.active').removeClass('active');
      $(this).addClass('active');
    });

    $("body").on("change", "#myBetsUsersUserCoinSelect", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      let agents = [];
      if ($("#agentSelect").val())
        agents = await getagentsByChildrenUser(
          betsStartDate,
          betsEndDate,
          $("#agentSelect").val(),
          $("#myBetsUsersUserCoinSelect").val()
        );
      else
        agents = await getagentsByUser(
          betsStartDate,
          betsEndDate,
          $("#myBetsUsersUserCoinSelect").val()
        );
      renderAgents(agents);
      saveMetaData(betsStartDate, betsEndDate);
    });

    $("body").on("change", "#agentSelect", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      let agents = [];
      if ($(e.currentTarget).val())
        agents = await getagentsByChildrenUser(
          betsStartDate,
          betsEndDate,
          $(e.currentTarget).val(),
          $("#myBetsUsersUserCoinSelect").val()
        );
      else
        agents = await getagentsByUser(
          betsStartDate,
          betsEndDate,
          $("#myBetsUsersUserCoinSelect").val()
        );
      renderAgents(agents);
      saveMetaData(betsStartDate, betsEndDate);
    });
  },
  hideFooterCasino: true
};

function saveMetaData(betsStartDate, betsEndDate) {
  localStorage.setItem("currencySelected", $("#myBetsUsersUserCoinSelect").val());
  localStorage.setItem("betsStartDate", betsStartDate);
  localStorage.setItem("betsEndDate", betsEndDate);
}

function renderAgents(agents) {
  if (agents) {
    let agentsView = ``;
    let total = 0;
    agents.forEach((agent) => {
      agentsView += ` <a href="#/mybetsuserdetails/${
        agent.parent_id
      }" class="mybetsusersrow">
          <span>${agent.agent} (${agent.bets})</span>
          <span>${Utils.formatNumber(agent.return)} </span>
      </a>`;
      total += parseFloat(agent.return);
    });

    document.getElementById("myAgents").innerHTML = agentsView;

    $("#totalBetsValue").text(Utils.formatNumber(total));
  }
}

export default MyBetsUsersAgent;
